import { render } from 'preact';
import { OverlayRoot } from './OverlayRoot.tsx';

let mounted = false;

/**
 * Resolves `#ui-root` and renders the single Preact tree that owns every overlay panel.
 * Idempotent, so each scene can call it during `create`.
 */
export function mountOverlay(): HTMLElement {
  const root = document.querySelector('#ui-root');

  if (!(root instanceof HTMLElement)) {
    throw new Error('Missing #ui-root for HTML overlays');
  }

  if (!mounted) {
    render(<OverlayRoot />, root);
    mounted = true;
  }

  return root;
}

export function showOverlay(root: HTMLElement): void {
  root.hidden = false;
}
